<template>
  <div class="main row">
    <div class="col-md-12">
      <KTCodePreview v-bind:title="isEdit ? 'Cập nhật khoản mục phí' : 'Thêm khoản mục phí'">
        <template v-slot:preview>
          <b-form @submit.prevent="onSubmit">
            <b-row class="mb-3">
              <b-col cols="4">
                <b-form-group>
                  <template #label>
                    Tên khoản mục phí <span class="text-danger">*</span>
                  </template>
                  <b-form-input
                    v-model="form.name"
                    placeholder="Nhập tên khoản mục"
                    required
                  />
                </b-form-group>
              </b-col>
              <b-col cols="3">
                <b-form-group>
                  <template #label>
                    Nhóm phí <span class="text-danger">*</span>
                  </template>
                  <b-form-select
                    v-model="form.costGroupId"
                    :options="costGroupOptions"
                    required
                  />
                </b-form-group>
              </b-col>
              <b-col cols="3">
                <b-form-group label="Loại quản lý">
                  <b-form-select
                    v-model="form.managementTypeId"
                    :options="managementTypeOptions"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="2">
                <b-form-group>
                  <template>
                    <label>Doanh nghiệp:</label>
                    <span class="text-danger">*</span>
                  </template>
                  <b-form-select
                    v-model="form.companyId"
                    :options="listCompany"
                    value-field="id"
                    text-field="name"
                    required
                  >
                    <template v-slot:first>
                      <b-form-select-option :value="null" disabled
                        >-- Doanh nghiệp --</b-form-select-option
                      >
                    </template>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="mb-3" v-if="isEdit">
              <b-col cols="3">
                <b-form-group label="Trạng thái">
                  <b-form-select v-model="form.status" :options="statusOptions" />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-button type="submit" variant="primary" :disabled="isSaving">
                  <i class="fas fa-save"></i> {{ isSaving ? 'Đang lưu...' : 'Lưu' }}
                </b-button>
                <b-button variant="secondary" class="ml-2" @click="goBack">
                  <i class="fas fa-arrow-left"></i> Quay lại
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </template>
      </KTCodePreview>
    </div>
  </div>
</template>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import ApiService from '@/core/services/api.service';
import { makeToastSuccess, makeToastFaile, handleError } from '@/utils/common';
import { COST_GROUP_TYPE } from '../constants';

export default {
  components: { KTCodePreview },
  data() {
    return {
      isEdit: false,
      isSaving: false,
      listCompany: [],
      form: {
        id: null,
        name: '',
        costGroupId: null,
        managementTypeId: null,
        companyId: null,
        status: 1,
      },
      costGroupOptions: [{ value: null, text: '-- Chọn nhóm phí --' }],
      managementTypeOptions: [{ value: null, text: '-- Không chọn --' }],
      statusOptions: [
        { value: 1, text: 'Hoạt động' },
        { value: 0, text: 'Ngừng' },
      ],
    };
  },
  created() {
    this.fetchCompany();
    this.fetchCostGroups();
    const id = this.$route.query.id;
    if (id) {
      this.isEdit = true;
      this.fetchDetail(id);
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Kế toán', route: '#' },
      { title: 'Khoản mục phí', route: '/budget/cost-items' },
      { title: this.isEdit ? 'Cập nhật' : 'Thêm mới' },
    ]);
  },
  methods: {
    makeToastSuccess,
    makeToastFaile,
    fetchCompany() {
      ApiService.get('/company').then((response) => {
        this.listCompany = response.data.data;
      });
    },
    fetchCostGroups() {
      ApiService.get('v2/cost-groups/all').then(({ data }) => {
        if (data.status === 200 && Array.isArray(data.data)) {
          const expenseGroups = data.data
            .filter((g) => Number(g.groupType) === COST_GROUP_TYPE.EXPENSE)
            .map((g) => ({ value: g.id, text: g.name }));
          const mgmtGroups = data.data
            .filter((g) => Number(g.groupType) === COST_GROUP_TYPE.MANAGEMENT)
            .map((g) => ({ value: g.id, text: g.name }));
          this.costGroupOptions = [{ value: null, text: '-- Chọn nhóm phí --' }, ...expenseGroups];
          this.managementTypeOptions = [{ value: null, text: '-- Không chọn --' }, ...mgmtGroups];
        }
      });
    },
    fetchDetail(id) {
      ApiService.get(`v2/cost-items/${id}`).then(({ data }) => {
        if (data.status === 200) {
          this.form = {
            id: data.data.id,
            name: data.data.name,
            costGroupId: data.data.costGroupId,
            managementTypeId: data.data.managementTypeId,
            companyId: data.data.companyId,
            status: data.data.status,
          };
        }
      });
    },
    onSubmit() {
      if (!this.form.companyId) {
        this.makeToastFaile('Vui lòng chọn doanh nghiệp!');
        return;
      }
      this.isSaving = true;
      const payload = { ...this.form };
      const request = this.isEdit
        ? ApiService.put('v2/cost-items', payload)
        : ApiService.post('v2/cost-items', payload);

      request
        .then(({ data }) => {
          if (data.status === 200) {
            this.makeToastSuccess(data.message);
            this.$router.push({ name: 'list-cost-items' });
          } else {
            this.makeToastFaile(data.message);
          }
        })
        .catch((err) => handleError(err))
        .finally(() => { this.isSaving = false; });
    },
    goBack() {
      this.$router.push({ name: 'list-cost-items' });
    },
  },
};
</script>
